import { TableRow, styled } from "@mui/material";
import { COLORS } from "../../constants/colors";

export const StyledDataRow = styled(TableRow)`
  &:hover {
    background-color: ${COLORS.SURFACE_HOVER};
  }

  &:last-child td {
    border-bottom: 0;
  }
`;
